export default "__VITE_PUBLIC_ASSET__f7e7fe57__"